import base from './base'
import qs from 'qs'

let controller = 'proxy'
let action = null

const Crawler = {
  async listZzZhuJianPrj (query, pageIndex = 1) {
    let querys = {
      'View_XZSP_SgxkzFilter.GCMC': query.prjName,
      'View_XZSP_SgxkzFilter.BH': query.prjNo,
      'View_XZSP_SgxkzFilter.JSDW': query.ownerName,
      'View_XZSP_SgxkzFilter.SGDW': query.contractorName,
      'View_XZSP_SgxkzFilter.PageIndex': pageIndex,
      'View_XZSP_SgxkzFilter.ParaHasXSSChar': 'False'
    }
    action = 'zhengzhouzhujian/projectlist/'
    let reqModel = {
      host: 'http://demo-jzmengzhoucgms.toubiao51.com',
      method: 'POST',
      controller: controller,
      action: action,
      auth: false,
      options: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      },
      data: qs.stringify(querys)
    }
    return base.requestRaw(reqModel)
  },

  async getZzZhuJianPrjDetail (tid) {
    action = `zhengzhouzhujian/projectdetail/${tid}`
    let reqModel = {
      host: 'http://demo-jzmengzhoucgms.toubiao51.com',
      method: 'POST',
      controller: controller,
      action: action,
      auth: false
    }
    return base.requestRaw(reqModel)
  },
}

export default Crawler